export default __webpack_public_path__ + "static/media/grails.8acc4267.svg";